import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { ONE_SURVEY } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { OneSurveyDataActionTypes } from './types';
import api from 'src/utils/api';
import { loadAllListQuestions } from '../../questions/allListQuestions/actions';
import { setTestAllData } from '../testData/actions';

export const loadOneSurvey =
  (
    id: number,
  ): ThunkAction<Promise<void>, State, null, OneSurveyDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: ONE_SURVEY + REQUEST });
    try {
      const payload = await api.loadOneSurvey(id);
      dispatch({ type: ONE_SURVEY + SUCCESS, payload });
      dispatch(loadAllListQuestions(id));
      dispatch(setTestAllData(payload));
    } catch (error) {
      dispatch({ type: ONE_SURVEY + FAILURE, error });
    }
  };

export const oneSurveyIdle = () => ({ type: ONE_SURVEY + IDLE });
